((app, ng) => {

    app.component("caseAccounts",
        {
            templateUrl: "/App/Client/Case/Accounts/case-accounts.html",
            controller: accountsController,
            bindings: {
                clientCase: "<",
                client: "<",
                advisors: "<",
                currentUser: "<",
            }
        });

    function accountsController(caseModalService, caseApi, carrierApi, custodianApi, taxQualificationApi, investmentAccountTypeApi, planTypeApi) {
        const $ctrl = this;

        const getCaseAccounts = (caseId) => {
            $ctrl.ui.loading = true;

            caseApi.getAccounts(caseId).then(response => {
                $ctrl.accounts = response;

                $ctrl.ui.loading = false;
            });

            planTypeApi.getPlanTypes().then(response => {
                $ctrl.planTypes = response;
            });
        }

        const addAccount = ($event) => {
            caseModalService.openAddAccount($ctrl.client, $ctrl.clientCase, $event).then(response => {
                if (!!response) getCaseAccounts($ctrl.clientCase.Id);
            });
        }

        const addFirelightAccount = ($event) => {
            caseModalService.openAddFirelightAccount($ctrl.client, $ctrl.clientCase, $event).then(response => {
                if (!!response) getCaseAccounts($ctrl.clientCase.Id);
            });
        }

        const toggleCollapse = (accountId) => {
            $ctrl.accountCollapseToggles[accountId] = !$ctrl.accountCollapseToggles[accountId];
            return $ctrl.accountCollapseToggles[accountId];
        }

        const onAccountDeleted = (accountId) => {
            const accountIndex = $ctrl.accounts.findIndex(account => {
                return account.InsuranceAccountId === accountId || account.InvestmentAccountId === accountId;
            });

            $ctrl.accounts.splice(accountIndex, 1);
        }

        ng.extend($ctrl,
            {
                addAccount,
                addFirelightAccount,
                toggleCollapse,
                onAccountDeleted,
            });

        $ctrl.$onInit = () => {
            $ctrl.ui = {};
            $ctrl.accountCollapseToggles = {};
            $ctrl.accounts = [];
            $ctrl.carriers = [];
            $ctrl.products = [];
            $ctrl.taxQualifications = [];
            $ctrl.investmentAccountTypes = [];

            getCaseAccounts($ctrl.clientCase.Id);

            carrierApi.getCarriers().then(response => {
                $ctrl.carriers = response;
            });

            custodianApi.getCustodians().then(response => {
                $ctrl.custodians = response;
            });

            taxQualificationApi.getTaxQualifications().then(response => {
                $ctrl.taxQualifications = response;
            });

            investmentAccountTypeApi.getInvestmentAccountTypes().then(response => {
                $ctrl.investmentAccountTypes = response;
            });
        }
    }

})(window.app, window.angular);